import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {moduloPerform} from '../../diccionarios/performValuesModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import { SeguimientoUserService } from '../../services/orden-proceso-services/seguimiento-user.service';
import { MantenedorParametrosRaspberryService } from '../../services/orden-proceso-services/mantenedor-parametros-raspberry.service';
import { MantenedorIoIndustriasPlcService } from '../../services/orden-proceso-services/mantenedor-io-industrias.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { PlantaService } from '../../services/general-services/planta.service';
import { LineaService } from '../../services/general-services/linea.service';
import { MantenedorProductoSpecsService } from '../../services/orden-proceso-services/mantenedor-producto-specs.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';

@Component({
  selector: 'app-mantenedor-producto-specs-perform',
  templateUrl: './mantenedor-producto-specs.component.html',
  styleUrls: ['./mantenedor-producto-specs.component.css']
})
export class MantenedorProductoSpecsComponent implements OnInit {

  titulo: string = "Solicitar ordenes de proceso";

  formulario: FormGroup;
  formularioCustom: FormGroup;

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;

  selectedRow: any;

  cmbPlanta: any[] = [];
  cmbLinea: any[] = [];

  memoryList: any[] = [];

  columnDefsModal: any[];
  rowDataModal: any[] = [];
  frameworkComponentsModal: any;
  gridApiModal: any;
  gridColumnApiModal: any;
  rowSelectionModal: any;

  textBoton: string;
  textoBuscar: string;
  textoBuscarRasp: string;
  mostrarFormulario = false;
  mostrarFormularioRasp = false;
  deshabilitarLineaRasp:boolean = true;

  tvcModulo: any;
  editableForm = false;

  loading: boolean = false;
  listaVacia: boolean = true;
  listaVaciaRasp: boolean = true;
  loadingRasbian: boolean = false;

  estadoContenedor: boolean = false;
  estadoBd: boolean = false;
  textoContenedor: string = "Solicitando";
  textoBd: string = "Solicitando";
  textoCantidadRasp = "Solicitando";
  textoCantidadNonRasp = "Solicitando";

  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  lineaSelected: any;


  cmbOpcion: any[] = [
    { clave: 1, valor: 'Activo' },
    { clave: 0, valor: 'Inactivo' }
  ];

  cmbOpcionModal: any[] = [
    { clave: true, valor: 'Activo' },
    { clave: false, valor: 'Inactivo' }
  ];

  check: HTMLInputElement;

  bandchek: boolean = true;
  banderaString: boolean;
  bandNew: boolean = true;



  @ViewChild('fileInput') fileInput: ElementRef;
  formInputFile: FormGroup;

  DATA = [];
  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private _commonForm: CommonFormService,
    private _planta: PlantaService,
    private _linea: LineaService,
    private _indsutriasIo: MantenedorIoIndustriasPlcService,
    private _productoSpecs: MantenedorProductoSpecsService,
    private _datos_Maestros: DatosMaestrosService,
    private _logServices : SeguimientoUserService,
  ) { }

  //URI: string = 'RASPBERRY- PARAMETRIZACION';
  URI: string = 'PRODUCTOS ESPECIFICACIONES';
  
  ngOnInit() {
    this._logServices.saveSeguimientoPerform(this.URI); //Ticket 30238 LOG de ingreso en modulos perform
    
    this.tvcModulo = moduloPerform;
    this.DAT_BTNS = this.tvcModulo.button.buttonsNombre;
    this.DAT_MSG = this.tvcModulo.mensajes;
    this.DAT_BTNCSS = this.tvcModulo.button.buttonsCss;

    this.formularioCustom = this.fb.group({
      idMaterial: ['', [Validators.minLength(6),Validators.maxLength(10)]],
      perGeneral: ['', [Validators.required]],
      descMaterial:['', [Validators.required]],
      perMax: ['', [Validators.required]],
      perMin: ['', [Validators.required]],
      peso: [''],
      pesoEmbalaje: [''],
      alturaCaja:[''],
      retardoRechazo: [''],
      confNsensor: [''],
      confHab:[''],
      usuarioRegister: [''],
      fecha:[''],
      linea:[''],
      planta:[''],
      habCodEan14:[''],
      habCodEan128:[''],
      habMayor:[''],
      habMenor:[''],
      habAlt:['']
    });

    this.formulario= this.fb.group({
      linea:[''],
      planta:['']
    });


    this.formInputFile = this.fb.group({
      multipart: ['', [Validators.required]]
    });
    this.cargarGrig();
    //*INVOCACION DE SERVICIOS AL INICIO
    //this.getAll();
    //this.getAllPlanta();
    this.getAllPlantaByUser();
    setTimeout(() => {
      //this.check = document.getElementById("idPropiedad") as HTMLInputElement;
      //this.check.checked = false;
    }, 200);
  }

  /** SERVICIOS */
  getAll() {
    this.loading = true;
    this._productoSpecs.getAllOrdenProductos().subscribe((res: any[]) => {
      this.loading = false;
      this.rowData = res;

      this.listaVacia = this.rowData.length > 0 ? false : true;
    }, (err) => {
      this.loading = false;
      this.rowData = this.DATA;
      this.listaVacia = this.rowData.length === 0 ? true : false;
    });
  }



  getAllPlanta() {
    this._planta.getAllbyPerfor().subscribe((res: any) => {
      this.cmbPlanta = res.respuesta;
    }, (err) => {
      this.cmbPlanta = [];
    });
  }

  getAllPlantaByUser() {
    this._planta.getAllbyPerforByUser(localStorage.getItem('userName')).subscribe((res: any) => {
      //this._planta.getAllbyPerforByUser('rtoro').subscribe((res: any) => {
      console.log('load',res.respuesta);
      this.cmbPlanta = res.respuesta;
    }, (err) => {
      console.log('err',err);
      this._util.mensajeErroToast("No se encontro Plantas asignadas a su usuario, por favor contacte al administrador",3000);
      this.cmbPlanta = [];
    });
  }

  /** FUNCIONES */
  nuevo() {
    this.textBoton = this.DAT_BTNS.guardar;
    this.titulo = "Guardar Parametrización Raspberry";
    this._commonForm.abrirFormularioParaGuardar(this);
  }

  /*editar({ rowData }) {
    let id = 0;
    this.cmbPlanta.forEach(element =>{
      if(element.nombre === rowData.nombrePlanta){
        id = element.id;
      }
    });
    this.cmbLinea = [{id:rowData.idLinea,nombre:rowData.nombreLinea}];
    const clonData = {
      active: rowData.active,
      ipRb: rowData.ipRb,
      nombre: rowData.nombre,
      idLinea: rowData.idLinea,
      port: rowData.port,
      idPlanta: id
    }
    this.textBoton = this.DAT_BTNS.editar;
    this.titulo = "Editar Parametrización Raspberry";
    this._commonForm.abrirFormularioParaEditar(this, clonData);
  }*/


  carfas(from,row){
     const obj = from.cmbLinea.find( e => e.id === row.data.idLinea);
     if(obj !== undefined)
      return obj.nombre;
     else
      return '?';
   }


  cargarGrig() {
    this.columnDefs = [
      /*{
        headerName: "Editar",
        cellRenderer: "buttonRenderer",
        width: 100,
        cellRendererParams: {
          onClick: this.procesarSolicitud.bind(this),
          label: "Editar",//this.tvcModulo.button.buttonsNombre.agregar,
          colorBoton: this.tvcModulo.button.buttonsCss.warning,
        },
      },*/
      {
        headerName: "Eliminar",
        cellRenderer: "buttonRenderer",
        width: 100,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: "Eliminar",//this.tvcModulo.button.buttonsNombre.agregar,
          colorBoton: this.tvcModulo.button.buttonsCss.alert,
        },
      },
      {
        headerName: "Editar",
        cellRenderer: "buttonRenderer",
        width: 100,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: "Editar",//this.tvcModulo.button.buttonsNombre.agregar,
          colorBoton: this.tvcModulo.button.buttonsCss.alert,
        },
      },
      {
        headerName: "Id Material",
        field: "idMaterial",
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: "Desc Material",
        field: "material.descripcionMaterial",
        sortable: true,
        filter: true,
        width: 300,
      },
      {
        headerName: "Porc. General",
        field: "perGeneral",
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: "Porc. Mínimo",
        field: "perMin",
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: "Porc. Máximo",
        field: "perMax",
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: "Usuario Registro",
        field: "usuarioRegister",
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: "Fecha",
        field: "fecha",
        sortable: true,
        filter: true,
        width: 200,
      },

    ];
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = "multiple";
  }


  changeRowColor(params) {
    if (params.data.active) {
      return { 'color': 'green', 'font-weight': 'bold' };
    } else {
      return { 'color': 'red', 'font-weight': 'bold' };
    }
  }

  changeRowColorStatus(params) {
    if (params.data.status) {
      return { 'color': 'green', 'font-weight': 'bold' };
    } else {
      return { 'color': 'red', 'font-weight': 'bold' };
    }
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onGridReadyModal(params) {
    this.gridApiModal = params.api;
    this.gridColumnApiModal = params.columnApi;
  }

  acciones(event) {
    console.log(event);
    if (event === "guardar") {
      if (this.editableForm) {
      } else {
        this.guardar();
      }
    }else if(event == "enviar"){
      this.enviarConfigRaspberry();
    } else {
      this.titulo = "Parametrización Raspbery";
      this._commonForm.limpiarYregrear(this);
    }
  }

  enviarConfigRaspberry(){

    this._util.confirmarSincronoPromesa(
      {
        title: this.tvcModulo.mensajes.guardar,
        text: ``,
        action: this.tvcModulo.button.buttonsNombre.guardar,
        funcion: this._indsutriasIo.enviarConfigPlc(this.formulario.value),
      }
    ).then((res: any) => {
      this.titulo = "Parametrización Raspberry";
        this.getAll();
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }


  eliminar({ rowData }) {
    this.loading = true;
    this._util.confirmarSincronoPromesa(
      {
        title: this.tvcModulo.mensajes.eliminar,
        text: ``,
        action: this.tvcModulo.button.buttonsNombre.eliminar,
        funcion: this._productoSpecs.deleteRegistro(rowData.idMaterial,rowData.idLinea),
      }
    ).then((res: any) => {
      this.rowData = this.rowData.filter((item) => item.idMaterial !== rowData.idMaterial);
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  guardar() {
    if(this.formularioCustom.get("peso").value <= 0){
      this._util.mensajeErrorVisto('El peso no puede ser menor o igual a 0',true,10000)
      return;
    }
    const clonData = {
      idMaterial: this.formularioCustom.get("idMaterial").value,
      perGeneral: this.formularioCustom.get("perGeneral").value,
      perMax: this.formularioCustom.get("perMax").value,
      perMin: this.formularioCustom.get("perMin").value,
      idLinea: this.lineaSelected,
      retardoRechazo: this.formularioCustom.get("retardoRechazo").value,
      peso: this.formularioCustom.get("peso").value,
      pesoEmbalaje: this.formularioCustom.get("pesoEmbalaje").value,
      alturaCaja: this.formularioCustom.get("alturaCaja").value,
      confNsensor: this.formularioCustom.get("confNsensor").value,
      habCodEan14:this.formularioCustom.get("habCodEan14").value,
      habCodEan128:this.formularioCustom.get("habCodEan128").value,
      habMenor:this.formularioCustom.get("habMenor").value,
      habMayor:this.formularioCustom.get("habMayor").value,
      habAlt:this.formularioCustom.get("habAlt").value
    }
    this.loading = true;
    if(this.bandNew === true){
      this._util.confirmarSincronoPromesa(
        {
          title: this.tvcModulo.mensajes.guardar,
          text: ``,
          action: this.tvcModulo.button.buttonsNombre.guardar,
          funcion: this._productoSpecs.crearProductoSpecs(clonData),
        }
      ).then((res: any) => {
        //this.titulo = "Parametrización Raspberry";
        document.getElementById('cerrarModal').click();
        this.selecionLinea();
        this.loading = false;
      }, () => {
        this.loading = false;
      });
    }else{
      this._util.confirmarSincronoPromesa(
        {
          title: this.tvcModulo.mensajes.actualizar,
          text: ``,
          action: this.tvcModulo.button.buttonsNombre.actualizar,
          funcion: this._productoSpecs.editarProductoSpecs(clonData),
        }
      ).then((res: any) => {
        //this.titulo = "Parametrización Raspberry";
        document.getElementById('cerrarModal').click();
        this.selecionLinea();
        this.loading = false;
      }, () => {
        this.loading = false;
      });
    }

  }

  editar({ rowData }) {
      this.bandNew = false;
      document.getElementById('abrirModal').click();
      this.formularioCustom.get("idMaterial").setValue(rowData.idMaterial);
      //this.formularioCustom.get("idMaterial").disabled;
      this.formularioCustom.get("idMaterial").disable();
      //this.formularioCustom.get("idMaterial").updateValueAndValidity();
      this.formularioCustom.get("perGeneral").setValue(rowData.perGeneral);
      this.formularioCustom.get('descMaterial').setValue(rowData.material.descripcionMaterial);
      this.formularioCustom.get("perMax").setValue(rowData.perMax);
      this.formularioCustom.get("perMin").setValue(rowData.perMin);
      this.lineaSelected,
      this.formularioCustom.get("retardoRechazo").setValue(rowData.retardoRechazo);
      this.formularioCustom.get("peso").setValue(rowData.peso);
      this.formularioCustom.get("pesoEmbalaje").setValue(rowData.pesoEmbalaje);
      this.formularioCustom.get("alturaCaja").setValue(rowData.alturaCaja);
      this.formularioCustom.get("confNsensor").setValue(rowData.confNsensor);
      this.formularioCustom.get("habCodEan14").setValue(rowData.habCodEan14);
      this.formularioCustom.get("habCodEan128").setValue(rowData.habCodEan128);
      this.formularioCustom.get("habMenor").setValue(rowData.habMenor);
      this.formularioCustom.get("habMayor").setValue(rowData.habMayor);
      this.formularioCustom.get("habAlt").setValue(rowData.habAlt);
  }

  sendEdicion(){
    this.loading = true;
    this._util.confirmarSincronoPromesa(
      {
        title: this.tvcModulo.mensajes.guardar,
        text: ``,
        action: this.tvcModulo.button.buttonsNombre.guardar,
        funcion: this._productoSpecs.crearProductoSpecs(this.formulario.value),
      }
    ).then((res: any) => {
      this.titulo = "Parametrización Raspberry";
      this.getAll();
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }



  callModalRasp({ rowData }) {
    this.deshabilitarLineaRasp = true;
    //this.plantilla.idLinea = rowData.idLinea;
    //this.lineaSeledted = this.plantilla.ipRb;
    document.getElementById('callModal').click();
    //this.getParamslinea();
  }


  callModal({ rowData }) {
    this.mostrarFormularioRasp = true;
  }

  getLineaPlantaByid(idPlanta) {
    const planta = this.cmbPlanta.find((e) => e.id === idPlanta);
    this._linea.lineasByCodigoPlantaActiva(planta.id).subscribe((res: any[]) => {
      this.cmbLinea = res;
      //this.cargarGridRasp();
    }, (err) => {
      this.cmbLinea = [];
      console.log(err);
    });
  }

  getLineaPlanta() {
    let idPlanta = this.formulario.get('planta').value;
    const planta = this.cmbPlanta.find((e) => e.id === idPlanta);
    console.log(planta);
    this._linea.getByIdbyPerfor(planta.id).subscribe((res: any[]) => {
      this.cmbLinea = res;
      if(this.cmbLinea.length>0){
        this.formulario.get('linea').setValue(this.cmbLinea[0].id);
        this.selecionLinea();
      }
    }, (err) => {
      this.cmbLinea = [];
      console.log(err);
    });
  }



  exportar() {
    const cabecera: any[] = [['DB', 'PROPIEDAD', 'POSICION', 'TDATO', 'LONGITUD', 'ENVIADO', 'STATUS']];
    const data: any[] = this.rowDataModal.map((x) => Object.assign({}, x));
    let body = [];
    data.forEach(e => {
      body.push({ "db": e.db, "propiedad": e.propiedad, "posicion": e.posicion, "tdato": e.tdato, "longitud": e.longitud, "enviado": e.enviado, "status": e.status });
    });
    this._util.exportCSV(cabecera, body, "config.csv");
  }

  clickChosseFile() {
    this.fileInput.nativeElement.value = '';
    this.formInputFile.get('multipart').setValue('');
    document.getElementById('csvInput').click();
  }

  async onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formInputFile.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formInputFile.get('multipart').setValue(file);
        this.importar(file);
      }
    }
  }

  async importar(file: any) {
    this.rowDataModal = [];
    const str = await this._util.readFileContent(file);
    const filas = str.split(/\r\n|\n/);
    const cabecera = filas[0].split(/\t|;/);
    let cuerpo: any[] = [];
    filas.forEach((col, i) => {
      if (i > 0) {
        let columna = filas[i].split(/\t|;/);
        if (columna.length == cabecera.length) {
          cuerpo.push({ "db": columna[0], "propiedad": columna[1], "posicion": columna[2], "tdato": columna[3], "longitud": columna[4], "enviado": columna[5], "status": columna[6] });
        }
      }
    });
    let hash = {};
    cuerpo = cuerpo.filter(o => hash[o.propiedad] ? false : hash[o.propiedad] = true);
    this.rowDataModal = cuerpo;
  }


  procesarSolicitud( { rowData } ){
    this.selectedRow = rowData;
    console.log(rowData);
    rowData.lote;
    rowData.ordenProceso;
    document.getElementById('abrirModal').click();

  }

  procesar(){
    this.formularioCustom.get('peso').enable();
    if(this.formulario.get('linea').value === ''){
      this._util.mensajeErroToast('Por favor elija una linea');
      return;
    }
    this.lineaSelected = this.formulario.get('linea').value;
    this.bandNew = true;
    this.formularioCustom.reset();
    this.formulario.get('linea').setValue(this.lineaSelected);
    this.formularioCustom.get("idMaterial").enable();
    document.getElementById('abrirModal').click();
    this.formularioCustom.get('perGeneral').setValue("2");
    this.formularioCustom.get('perMax').setValue("2");
    this.formularioCustom.get('perMin').setValue("2");
    this.formularioCustom.get('pesoEmbalaje').setValue("0");
    this.formularioCustom.get('retardoRechazo').setValue("400");
    this.formularioCustom.get('confNsensor').setValue("1");
  }

  buscar(){
    if(this.formularioCustom.get('idMaterial').value.length > 1){
      this._datos_Maestros.getMaterialxId(this.formularioCustom.get('idMaterial').value).subscribe((res: any) => {
        //this.cargarGridRasp();
        this.formularioCustom.get('descMaterial').setValue(res.dscaMaterial);
        console.log(res);
      }, (err) => {

        console.log(err);
      });
      this._productoSpecs.buscarMaterialPresentacion(this.formularioCustom.get('idMaterial').value).subscribe((res: any) => {
        //this.cargarGridRasp();
        this.formularioCustom.get('peso').setValue(res.pesoBruto*1000);
        if(this.formularioCustom.get('peso').value === 0)
          this.formularioCustom.get('peso').enable();
        else
          this.formularioCustom.get('peso').disable();
        this.formularioCustom.get('alturaCaja').setValue(res.altura);
        console.log(res);
      }, (err) => {

        console.log(err);
      });
    }

  }

  limpiarDes(){
    this.formularioCustom.get('descMaterial').setValue("");
  }

  selecionLinea(){
    this.lineaSelected =  this.formulario.get('linea').value;
    this.loading = true;
    this._productoSpecs.buscarbyIdLinea(this.formulario.get('linea').value).subscribe((res: any) => {
      this.loading = false;
      this.rowData = res;

      this.listaVacia = this.rowData.length > 0 ? false : true;
    }, (err) => {
      this.loading = false;
      this.rowData = this.DATA;
      this.listaVacia = this.rowData.length === 0 ? true : false;
    });
  }

  changeValue(){
    console.log(this.formularioCustom.get('habCodEan14').value)
  }

}
